import { jsx as i } from "react/jsx-runtime";
import n from "react";
import { noop as k } from "../../utils/functional.js";
import { isExternalUrl as d } from "../../utils/links.js";
import { getButtonClassName as x, ButtonContent as B } from "./Button.js";
const M = n.forwardRef(function(t, a) {
  const {
    to: o,
    title: m = "",
    tabIndex: s,
    target: f = "",
    onClick: l = k,
    isHrefProp: r = !1,
    Component: c
  } = t, u = n.useMemo(() => x(t), [t]), e = d(o), C = e ? "a" : c || "a", p = n.useMemo(() => e || r ? { href: o } : { to: o }, [o, e, r]);
  return /* @__PURE__ */ i(
    C,
    {
      ref: a,
      className: u,
      tabIndex: s,
      title: m,
      target: f,
      rel: "noopener noreferrer",
      onClickCapture: l,
      ...p,
      children: /* @__PURE__ */ i(B, { ...t })
    }
  );
});
export {
  M as LinkButton
};
